import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

export const reportCardAPI = {
  getAll: async (params = {}) => {
    const response = await apiClient.get("/teacher/report-cards", { params });
    return unwrapApiResponse(response);
  },

  getById: async (id) => {
    const response = await apiClient.get(`/teacher/report-cards/${id}`);
    return unwrapApiResponse(response);
  },

  create: async (data) => {
    const response = await apiClient.post("/teacher/report-cards", data);
    return unwrapApiResponse(response);
  },

  update: async (id, data) => {
    const response = await apiClient.patch(`/teacher/report-cards/${id}`, data);
    return unwrapApiResponse(response);
  },

  delete: async (id) => {
    const response = await apiClient.delete(`/teacher/report-cards/${id}`);
    return unwrapApiResponse(response);
  },
};
